import {removeToken, setToken} from "@/js/utils/CookieUtil";
import Tear from "@/js/utils/Tear";
import Http from "@/js/api/Http";
import {Api} from "@/js/api/Api";


export default class User {

  static listeners = {}

  static backFromPreview

  static saveInfo = (data) => {
    User.info = data
    sessionStorage.setItem('userInfo', JSON.stringify(data))
  }

  static saveToken = (data) => {
    setToken(data)
  }

  static getInfo = () => {
    return Http.req(Api.user.info, {})
  }


  static readInfo = async () => {
    const {data} = await User.getInfo()
    User.info = data
  }

  static isAdmin() {
    return User.info.roleId < 3
  }

  static logout = () => {
    removeToken()
    sessionStorage.clear()
    User.info = null
    User.routes = null
    User._notifyLogout()
    Tear.to(`/login`)
  }

  static calcUnreadMsg = (tree, msgList, parent) => {
    if (!tree || tree.length === 0) {
      return
    }
    for (let item of tree) {
      let {meta} = item
      if (!meta) {
        meta = {}
        item.meta = meta
      }
      meta.unread = (msgList.find(msg => msg.id == meta.name) || {}).count || 0
      User.calcUnreadMsg(item.children, msgList, item)
      if (parent) {
        parent.meta.unread += meta.unread
      }
    }
  }

  static getUnreadMsg = async () => {
    const {data} = await Http.req(Api.common.msgCount)
    const routes = User.routes
    User.calcUnreadMsg(routes, data)
  }

  static addListener(key, listener) {
    User.listeners[key] = listener
  }

  static removeListener(key) {
    delete User.listeners[key]
  }

  static _notifyLogout() {
    const listeners = User.listeners;
    if (!listeners) {
      return
    }
    for (let key in listeners) {
      listeners[key]()
    }
  }
}
